// extracted by mini-css-extract-plugin
export default {"title":"description_title__K96xC","questionIcon":"description_questionIcon__eVYuE","description":"description_description__kAc1w","section":"description_section__Qs0Pr"};